import React from 'react';
import classes from './FormItems.module.css';

interface FormTextAreaProps {
  placeholder?: string
  required?: boolean
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  id?: string;
  name?: string;
  style?: any;
}

const FormTextArea = (props: FormTextAreaProps) => {

  return (
    <div className={classes.formcontroltextarea}>
      <textarea
        id={props.id}
        placeholder={props.placeholder}
        onChange={props.onChange}
        required={props.required}
        name={props.name}
        style={props.style}
      ></textarea>
    </div>
  )
}

export default FormTextArea;